<div class="edit-map-wrapper">
  <div
    #mapContainer
    class="map-container"></div>
</div>
